import CartEndpoints from "../lib/cart/CartEndpoints";

export const clearUpdateLockExpiration = (updateLockExpirationTimeoutID) => {
  clearTimeout(updateLockExpirationTimeoutID);
};

export const shouldRepark = (instruction, currentCart) => {
  if (!instruction.shouldRepark) return false;
  if (currentCart <= 0) return false;
  return instruction.desiredCartId !== currentCart;
};

export const getReparkMessage = (instruction) => {
  return `Ta med dig din vagn och byt plats med vagn ${instruction.desiredCartId} från ${instruction.parkPosition}${instruction.parkLocation}`;
};

export const reparkCart = (instruction, currentCart) => {
  return CartEndpoints.parkCart(currentCart, instruction.parkPosition, instruction.parkLocation);
};
